module.exports = __webpack_public_path__ + "assets/img/img-advice-question.13ee3993.svg";